var _path, _path2, _g, _path3, _g2, _path4, _g3, _path5, _path6, _g4, _path7, _path8, _path9, _path0, _g5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPetProtectCopayActive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.477 19.8697C39.477 21.1269 39.3602 22.3577 39.1328 23.5495C39.0408 24.0369 38.9302 24.5161 38.8032 24.9893C37.9944 27.9993 36.4894 30.7211 34.4702 32.9755C34.4004 33.0513 34.3328 33.1293 34.2612 33.2029C30.6714 37.0937 25.5294 39.5287 19.818 39.5287C10.5108 39.5287 2.71478 33.0617 0.67918 24.3747C0.33938 22.9291 0.15918 21.4199 0.15918 19.8697C0.15918 18.7537 0.25118 17.6579 0.43338 16.5931C1.99178 7.29409 10.0766 0.210693 19.818 0.210693C30.6754 0.210693 39.477 9.01229 39.477 19.8697Z",
    fill: "#2E6084"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2_2546",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.43358 16.5932C0.25118 17.658 0.15918 18.7536 0.15918 19.8696C0.15918 21.4198 0.33938 22.9292 0.67938 24.3748C2.71498 33.0618 10.511 39.5288 19.8182 39.5288C25.5294 39.5288 30.6714 37.0938 34.2614 33.2028C34.333 33.1292 34.4006 33.0512 34.4704 32.9756C36.4894 30.721 37.9946 27.9994 38.8034 24.9892C38.9302 24.5162 39.041 24.0368 39.133 23.5496C39.3604 22.3578 39.477 21.127 39.477 19.8696C39.477 9.01222 30.6756 0.210815 19.8182 0.210815C10.0768 0.210815 1.99198 7.29422 0.43358 16.5932Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2_2546)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.2186 6.95238H12.9566C12.0936 6.95238 11.2368 6.33018 11.2368 5.75479V5.54538C11.2368 4.96999 12.0936 4.45078 12.9566 4.45078H15.1454C16.0086 4.45078 16.709 4.08659 16.709 3.51118C16.709 2.93578 17.4094 2.57458 18.2724 2.57458H31.906C33.8446 3.82538 35.627 5.07618 37.2186 6.95238Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2_2546",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.43358 16.5932C0.25118 17.658 0.15918 18.7536 0.15918 19.8696C0.15918 21.4198 0.33938 22.9292 0.67938 24.3748C2.71498 33.0618 10.511 39.5288 19.8182 39.5288C25.5294 39.5288 30.6714 37.0938 34.2614 33.2028C34.333 33.1292 34.4006 33.0512 34.4704 32.9756C36.4894 30.721 37.9946 27.9994 38.8034 24.9892C38.9302 24.5162 39.041 24.0368 39.133 23.5496C39.3604 22.3578 39.477 21.127 39.477 19.8696C39.477 9.01222 30.6756 0.210815 19.8182 0.210815C10.0768 0.210815 1.99198 7.29422 0.43358 16.5932Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2_2546)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.7637 23.8541V24.1201C9.7637 24.8539 9.1681 25.4497 8.4341 25.4497H-6.4043C-6.3937 25.3725 -6.3803 25.2981 -6.3669 25.2209C-6.0559 23.3595 -5.5427 21.5671 -4.8487 19.8653H2.5839C3.3177 19.8653 3.9135 20.4609 3.9135 21.1949C3.9135 21.9289 4.5091 22.5245 5.2431 22.5245H8.4341C9.1681 22.5245 9.7637 23.1201 9.7637 23.8541Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2_2546",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.43358 16.5932C0.25118 17.658 0.15918 18.7536 0.15918 19.8696C0.15918 21.4198 0.33938 22.9292 0.67938 24.3748C2.71498 33.0618 10.511 39.5288 19.8182 39.5288C25.5294 39.5288 30.6714 37.0938 34.2614 33.2028C34.333 33.1292 34.4006 33.0512 34.4704 32.9756C36.4894 30.721 37.9946 27.9994 38.8034 24.9892C38.9302 24.5162 39.041 24.0368 39.133 23.5496C39.3604 22.3578 39.477 21.127 39.477 19.8696C39.477 9.01222 30.6756 0.210815 19.8182 0.210815C10.0768 0.210815 1.99198 7.29422 0.43358 16.5932Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2_2546)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.3048 19.0547H32.426C32.0898 19.0547 31.7842 18.9173 31.5652 18.6983C31.3462 18.4791 31.209 18.1739 31.209 17.8373C31.209 17.1647 31.7534 16.6201 32.426 16.6201H35.3032C35.5158 16.6201 35.7104 16.5339 35.85 16.3921C35.9916 16.2527 36.0778 16.0581 36.0778 15.8455C36.0778 15.4185 35.7304 15.0711 35.3032 15.0711H34.1966C33.524 15.0711 32.9794 14.5265 32.9794 13.8537V13.6325C32.9794 12.9597 33.524 12.4153 34.1966 12.4153H38.2422C39.2736 14.4601 39.984 16.6955 40.3048 19.0547Z",
    fill: "white"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9272 34.3887L15.8568 31.3835V26.8833C15.8568 24.7559 19.721 23.0315 19.721 23.0315C21.8552 23.0315 23.585 24.7559 23.585 26.8833V34.3723H31.9378L32.2688 21.6893L19.721 11.2651L7.78223 21.5777L7.82363 34.4537L13.8948 34.3723L15.9272 34.3887Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_2_2546",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 40H40V0H0V40Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_2_2546)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.00977 38.6872H35.7216V34.7666H4.00977V38.6872Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4066 18.9867V34.4587H7.46582L7.60742 21.5445L10.4066 18.9867Z",
    fill: "#73DAD2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3901 38.6192H35.6389V34.9356H10.3901V38.6192Z",
    fill: "#DBF2EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8153 11.1052C19.8865 11.0454 19.9876 11.0405 20.0637 11.0904L20.0838 11.1053L32.2898 21.3715C32.3302 21.4055 32.356 21.4533 32.3625 21.5051L32.3642 21.5312V34.6316C32.3642 34.7392 32.2828 34.8278 32.1782 34.8391L32.1555 34.8403H23.8027C23.6951 34.8403 23.6065 34.7589 23.5952 34.6544L23.594 34.6316V27.1426C23.594 25.1308 21.9577 23.4997 19.9387 23.4997C17.942 23.4997 16.3196 25.0948 16.2838 27.0757L16.2832 27.1426V32.5898C16.2832 32.7051 16.1897 32.7985 16.0745 32.7985C15.9669 32.7985 15.8783 32.7171 15.867 32.6126L15.8658 32.5898V27.1426C15.8658 24.9 17.6894 23.0823 19.9387 23.0823C22.1648 23.0823 23.9737 24.8627 24.0108 27.0734L24.0114 27.1426V34.4228H31.9468V21.6284L19.9494 11.5376L7.93058 21.6284V34.4228L14.1125 34.4229C14.2201 34.4229 14.3086 34.5043 14.32 34.6089L14.3212 34.6316C14.3212 34.7392 14.2398 34.8278 14.1352 34.8391L14.1125 34.8403H7.72188C7.61431 34.8403 7.52574 34.7589 7.51441 34.6544L7.51318 34.6316V21.5312C7.51318 21.4784 7.53322 21.4278 7.56869 21.3895L7.58769 21.3714L19.8153 11.1052Z",
    fill: "#0C2A4A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.86279 38.7254H10.427V35.0032H3.86279V38.7254Z",
    fill: "#73DAD2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.08321 34.5579H35.795C35.9103 34.5579 36.0037 34.6514 36.0037 34.7666V38.6872C36.0037 38.8025 35.9103 38.8959 35.795 38.8959H4.08321C3.96795 38.8959 3.87451 38.8025 3.87451 38.6872V34.7666C3.87451 34.6514 3.96795 34.5579 4.08321 34.5579ZM35.5862 38.4784V34.9752H4.29181V38.4784H35.5862Z",
    fill: "#0C2A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.746 11.2023C19.2337 10.7972 19.9575 10.8642 20.3626 11.3519C20.757 11.8268 20.7039 12.5255 20.2506 12.9359L20.213 12.9685L7.91621 23.1823C7.42848 23.5874 6.7047 23.5204 6.2996 23.0327C5.90515 22.5578 5.95827 21.8591 6.41156 21.4487L6.44919 21.4161L18.746 11.2023Z",
    fill: "#00505B",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8398 19.6865L19.8662 6.92151L4.34961 19.6623L6.52141 22.3649L19.8662 11.2651L33.4268 22.3891L35.8398 19.6865Z",
    fill: "#73DAD2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.06053 19.598L19.5769 6.76061C19.6533 6.69745 19.7635 6.69667 19.8407 6.75873L35.8145 19.5961C35.905 19.6689 35.9188 19.8014 35.8451 19.8912L33.5285 22.7144C33.4551 22.8038 33.3231 22.8165 33.234 22.7427L19.7112 11.5372L6.50036 22.7412C6.41596 22.8127 6.29193 22.8053 6.21646 22.7283L6.19995 22.7093L4.02815 19.8861C3.95963 19.797 3.97395 19.6696 4.06053 19.598ZM35.3886 19.7892L19.7116 7.19043L4.48161 19.791L6.39721 22.2812L19.575 11.1058C19.6457 11.0458 19.7466 11.0403 19.823 11.0895L19.8431 11.1043L33.3388 22.2874L35.3886 19.7892Z",
    fill: "#0C2A4A"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8428 34.6949L18.5206 32.0967H10.6128L11.2906 34.6949H17.8428Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6126 31.888H18.5204C18.6571 31.888 18.7569 32.0172 18.7224 32.1494L18.0446 34.7476C18.0206 34.8395 17.9376 34.9036 17.8426 34.9036H11.2904C11.1954 34.9036 11.1125 34.8395 11.0885 34.7476L10.4107 32.1494C10.3762 32.0172 10.476 31.888 10.6126 31.888ZM17.6813 34.4862L18.2503 32.3054H10.8827L11.4517 34.4862H17.6813Z",
    fill: "#0C2A4A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7681 32.1744L11.4459 34.7726H12.8439L12.1661 32.1744H10.7681Z",
    fill: "#00505B",
    fillOpacity: 0.15
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_2_2546",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 40H40V0H0V40Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_2_2546)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.90771 38.8826H36.8943V38.5284H2.90771V38.8826Z",
    fill: "#082B48"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.90771 39.5906H36.8943V38.8826H2.90771V39.5906Z",
    fill: "#73DAD2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.43047 10.5619C8.45827 10.8305 8.24047 11.0481 7.97207 12.0203C7.70347 11.0481 7.48587 10.8305 6.51367 10.5619C7.48587 10.2933 7.70347 10.0757 7.97207 9.10352C8.24047 10.0757 8.45827 10.2933 9.43047 10.5619Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.8774 7.84141C32.9052 8.10981 32.6874 8.32761 32.419 9.29981C32.1504 8.32761 31.9326 8.10981 30.9604 7.84141C31.9326 7.57281 32.1504 7.35521 32.419 6.38281C32.6874 7.35521 32.9052 7.57281 33.8774 7.84141Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.7642 23.8541V24.1201C53.7642 24.8539 53.1684 25.4497 52.4346 25.4497H37.5962C37.6068 25.3725 37.62 25.2981 37.6334 25.2209C37.9444 23.3595 38.4578 21.5671 39.1518 19.8653H46.5844C47.3182 19.8653 47.9138 20.4609 47.9138 21.1949C47.9138 21.9289 48.5096 22.5245 49.2434 22.5245H52.4346C53.1684 22.5245 53.7642 23.1201 53.7642 23.8541Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.6814 27.4858C34.7092 27.7542 34.4916 27.972 34.223 28.9442C33.9546 27.972 33.7368 27.7542 32.7646 27.4858C33.7368 27.2172 33.9546 26.9994 34.223 26.0272C34.4916 26.9994 34.7092 27.2172 35.6814 27.4858Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPetProtectCopayActive);
export default __webpack_public_path__ + "static/media/pet-protect-copay-active.13a27e32dff502a736242b4db7ec4384.svg";
export { ForwardRef as ReactComponent };